import type { FeatureManifest } from '../registry.js';
import { teamMemo } from '../teams/cache.js';
import { warMemo } from './memo.js';

/**
 * CP-04 Team Market War: the live board (realtime `war.lb`, polling fallback) opened from the
 * team screen, and the results card on the map after a war ends. The map hook runs once a
 * session for team members (or while a war's results are unseen): it remembers the team's war
 * and, once it is over, shows the chest the API delivered.
 *
 * Same-group exception to "features never import another feature": war is part of Market Teams
 * (its API routes need the teams flag as well) and reads only the teams feature's shared
 * helpers: teams/cache.ts (is the player in a team; player-tagged memos), teams/shared.tsx
 * (server clock, countdown, refusal text) and teams/icon.tsx. War's own state and API calls
 * live in this folder.
 */
export default {
  id: 'war',
  flag: 'war',
  unlock: 'teams',
  online: true,
  art: ['teams'],
  provides: ['war', 'warResult'],
  mapOrder: 20,
  mapDue: (a) => {
    if (a.remote.flags.teams === false || a.services.sync.status === 'offline' || a.session.checked.has('war')) return false;
    const w = warMemo(a);
    return (w !== null && !w.shown) || teamMemo(a).teamId !== null;
  },
  load: () => import('./index.js'),
} satisfies FeatureManifest;
